// 菜单的树结构 -- 侧边菜单
// 后续新增菜单的话 需要在这里做新增
export const menuList = [
  {
    ownId: 1,
    name: "行政管理",
    icon: "el-icon-office-building",
    route_path: "/admin",
    code: "admin.administration",
  },
  {
    ownId: 2,
    name: "请假审批",
    icon: "el-icon-document",
    route_path: "/admin/leave",
    code: "admin.administration.holiday",
  },
  {
    ownId: 3,
    name: "用章审批",
    icon: "el-icon-s-check",
    route_path: "/admin/stamp",
    code: "admin.administration.stamp",
  },
  {
    ownId: 4,
    name: "采购审批",
    icon: "el-icon-s-order",
    route_path: "/admin/procurement",
    code: "admin.administration.purchase",
  },
  {
    ownId: 5,
    name: "低值易耗申领",
    icon: "el-icon-goods",
    route_path: "/admin/consumable",
    code: "admin.administration.consumable",
  },
  {
    ownId: 6,
    name: "日常消耗借用",
    icon: "el-icon-box",
    route_path: "/admin/material",
    code: "admin.administration.dailyassetsloan",
  },
  {
    ownId: 7,
    name: "维修管理",
    icon: "el-icon-s-tools",
    route_path: "/maintenance",
    code: "admin.repair",
  },
  {
    ownId: 8,
    name: "维修列表",
    icon: "el-icon-document-copy",
    route_path: "/maintenance/record",
    code: "admin.repair.repairlist",
  },
  {
    ownId: 9,
    name: "物资管理",
    icon: "el-icon-box",
    route_path: "/material-management",
    code: "admin.assets",
  },
  {
    ownId: 10,
    name: "物资类别",
    icon: "el-icon-s-cooperation",
    route_path: "/material-management/category",
    code: "admin.assets.category",
  },
  {
    ownId: 11,
    name: "固定物资",
    icon: "el-icon-lock",
    route_path: "/material-management/fixed",
    code: "admin.assets.fixed",
  },
  {
    ownId: 12,
    name: "日常消耗",
    icon: "el-icon-s-home",
    route_path: "/material-management/daily",
    code: "admin.assets.daily",
  },
  {
    ownId: 13,
    name: "低值易耗",
    icon: "el-icon-goods",
    route_path: "/material-management/inventory",
    code: "admin.assets.consumable",
  },
  {
    ownId: 14,
    name: "食材物资",
    icon: "el-icon-food",
    route_path: "/material-management/food-material",
    code: "admin.config.food",
  },
  {
    ownId: 15,
    name: "物资日志",
    icon: "el-icon-document",
    route_path: "/material-management/log",
    code: "admin.assets.log",
  },
  {
    ownId: 16,
    name: "入库记录",
    icon: "el-icon-download",
    route_path: "/material-management/log/inbound",
    code: "admin.assets.log.inStock",
  },
  {
    ownId: 17,
    name: "出库记录",
    icon: "el-icon-upload",
    route_path: "/material-management/log/outbound",
    code: "admin.assets.log.outStock",
  },
  {
    ownId: 18,
    name: "物资报废",
    icon: "el-icon-delete",
    route_path: "/material-management/log/scrap",
    code: "admin.assets.log.scrap",
  },
  {
    ownId: 19,
    name: "预警信息",
    icon: "el-icon-warning-outline",
    route_path: "/material-management/log/warning",
    code: "admin.assets.log.warning",
  },
  {
    ownId: 20,
    name: "结余记录",
    icon: "el-icon-money",
    route_path: "/material-management/log/balance",
    code: "admin.assets.log.balance",
  },
  {
    ownId: 21,
    name: "配置管理",
    icon: "el-icon-setting",
    route_path: "/config",
    code: "admin.config",
  },
  {
    ownId: 22,
    name: "请假类型",
    icon: "el-icon-date",
    route_path: "/config/leave-type",
    code: "admin.config.holidaytype",
  },
  {
    ownId: 23,
    name: "用章类型",
    icon: "el-icon-edit-outline",
    route_path: "/config/stamp-type",
    code: "admin.config.stamptype",
  },
  {
    ownId: 24,
    name: "部门管理",
    icon: "el-icon-s-operation",
    route_path: "/config/department",
    code: "admin.config.department",
  },
  {
    ownId: 25,
    name: "供应商管理",
    icon: "el-icon-truck",
    route_path: "/config/supplier",
    code: "admin.config.supplier",
  },
  {
    ownId: 26,
    name: "二维码管理",
    icon: "el-icon-document-copy",
    route_path: "/config/qrcode",
    code: "admin.config.qrcode",
  },
  {
    ownId: 27,
    name: "审批层级",
    icon: "el-icon-document-checked",
    route_path: "/config/approval",
    code: "admin.config.approval",
  },
  {
    ownId: 28,
    name: "审批类型",
    icon: "el-icon-s-management",
    route_path: "/config/atype",
    code: "admin.config.approveType",
  },
  {
    ownId: 29,
    name: "信息管理",
    icon: "el-icon-phone-outline",
    route_path: "/contact",
    code: "admin.contacts",
  },
  {
    ownId: 30,
    name: "职工信息",
    icon: "el-icon-user",
    route_path: "/contact/staff",
    code: "admin.contacts.employee",
  },
  {
    ownId: 31,
    name: "权限管理",
    icon: "el-icon-key",
    route_path: "/permission",
    code: "admin.permission",
  },
  {
    ownId: 32,
    name: "角色管理",
    icon: "el-icon-lock",
    route_path: "/permission/role-permission",
    code: "admin.permission.role",
  },
  {
    id: 1000,              // 对应 ownId，字符串形式
    name: "设置",
    route_path: "/system",
    code: "",
    parent_id: -1,        // 顶级菜单用 -1 表示
    endType: 2,            // 按后端接口给的示例写
    icon: "el-icon-setting",
    is_public: true
  },
  {
    id: 1001,
    name: "个人信息",
    route_path: "/system/user",
    code: "",
    parent_id: 1000,        // 父菜单是设置 ownId
    endType: 2,
    icon: "el-icon-user",
    is_public: true
  }
];


// 所有人可以见的设置不需要权限 这个要怎么处理
